import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/assets/logo-dark.svg?react';
import { useConsentStore } from '@/stores/consentStore';

const Footer: React.FC = () => {
  const openPreferencesModal = useConsentStore((state) => state.openPreferencesModal);

  const handleManageCookiesClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openPreferencesModal();
  };

  return (
    <footer className="footer bg-muted/30 border-t border-border">
      <div className="container py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-10">
          <div className="col-span-2 lg:col-span-1 mb-6 lg:mb-0">
             <Link to="/" className="flex items-center space-x-2.5 mb-3">
                <span className="grid h-9 w-9 place-content-center rounded-xl bg-slate-900 shadow-sm ring-1 ring-slate-900/10">
                  <Logo className="h-5 w-5" />
                </span>
                <span className="font-semibold text-2xl tracking-tight font-sans">LendLifted</span>
             </Link>
            <p className="text-sm text-muted-foreground">
              Financing-enabled checkout and conversion insights for high-ticket service businesses.
            </p>
          </div>
          <div>
            <h5 className="font-semibold mb-3 text-foreground">Product</h5>
            <ul className="space-y-2 text-sm">
              <li><Link to="/features" className="hover:text-primary transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="hover:text-primary transition-colors">Pricing</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Demo Request</Link></li>
            </ul>
          </div>
          <div>
            <h5 className="font-semibold mb-3 text-foreground">Company</h5>
            <ul className="space-y-2 text-sm">
              <li><Link to="/features" className="hover:text-primary transition-colors">How it Works</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h5 className="font-semibold mb-3 text-foreground">Support</h5>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="hover:text-primary transition-colors">Support</Link></li>
              <li><Link to="/pricing" className="hover:text-primary transition-colors">Billing</Link></li>
            </ul>
          </div>
          <div>
            <h5 className="font-semibold mb-3 text-foreground">Legal</h5>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-primary transition-colors">Terms of Service</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-primary transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-border pt-8 text-center text-xs text-muted-foreground">
          <span>&copy; {new Date().getFullYear()} LendLifted. All rights reserved.</span>
          <span className="mx-1 sm:mx-2">|</span>
           <a href="#" onClick={handleManageCookiesClick} className="hover:text-primary hover:underline">
            Cookie Preferences
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
